module.exports = __webpack_public_path__ + "static/media/Buttonblue.78d65c9c.svg";